import * as React from 'react';
import { useState } from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import styled from 'styled-components';

import { Link } from 'stile-shared/src/components/2024/common/Link';
import { Section } from 'stile-shared/src/components/2024/layout/Section';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { TrialFormAu } from 'components/common/TrialFormAu';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Enquire now"
      description="Getting Stile at your school."
      slug={props.location.pathname}
    />
  );
}

const FormSection = styled<typeof Section>(Section)`
  .content {
    padding-bottom: 100px;
    @media (max-width: 768px) {
      padding-bottom: 80px;
    }
  }
  .grid-layout {
    margin-top: 0 !important;
  }
  .column {
    grid-column: span 6;
    display: flex;
    flex-direction: column;
    gap: 16px;
    @media (max-width: 768px) {
      grid-column: span 12;
    }
  }
  .column h6 {
    margin: 16px 0 0;
  }
  .column p {
    margin: 0;
  }
`;

function SetUpTrialPage(props: PageProps) {
  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  return (
    <PageLayout {...props}>
      <FormSection>
        <div className="column">
          <h4>Ready to find out more?</h4>
          <TrialFormAu onSubmissionSuccess={setSubmissionSuccess} />
        </div>

        {!submissionSuccess && (
          <div className="column">
            <h6>Getting Stile at your school</h6>
            <p>
              Stile partners with schools to supercharge their existing science programs, or in some
              cases, build a brand new program from the ground-up. Over the years, we've found the
              most valuable place to start is to simply have a chat.
            </p>
            <p>
              We're more than happy to put you in touch with a{' '}
              <Link openInNewTab url="/why-choose-stile/what-teachers-are-saying/">
                school nearby
              </Link>{' '}
              for you to hear about Stile from a colleague first hand.
            </p>

            <h6>Pricing</h6>
            <p>
              Stile has a simple per-student annual pricing structure. You only pay for the number
              of students you enrol – subscribe for a class, a year level, or your whole school.
              There are no setup fees, data storage is unlimited and teacher accounts are free.
            </p>
            <p>
              We really want to help ensure <em>every</em> student has access to a world-class
              science education. If your school loves Stile but can't afford it, chat to us about
              our Grants and Assistance Program.
            </p>
          </div>
        )}
      </FormSection>
    </PageLayout>
  );
}

export default SetUpTrialPage;
